import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Direcciones } from '../../core/model/direcciones';
import { Provincias } from '../../core/model/provincias';
import { Userprofile } from '../../core/model/users';
import { AuthenticationService } from '../../core/services/authentication.service';
import { DireccionesService } from '../../core/services/direcciones.service';
import { PopulateService } from '../../core/services/populate.service';
import { UsersService } from '../../core/services/users.service';

@Component({
  selector: 'app-direccion-solicitudes',
  templateUrl: './direccion-solicitudes.component.html',
  styleUrls: ['./direccion-solicitudes.component.css']
})
export class DireccionSolicitudesComponent implements OnInit {
  closeBtnName: string;
  direcciones: Direcciones[];
  updateDireccion: Direcciones;
  nuevaDireccion: Direcciones;
  modalRef: BsModalRef;
  model = new Direcciones();
  provinciaList: Provincias[];
  statusCode: number;
  selectedIdProvincia = 0;
  minCodPostal = false;
  processValidation = false;
  mensajeToShow: string;
  requestProcessing = false;
  idUsuario: number;
  tablaVisible = true;

  constructor(private direccionTemplate: BsModalRef,
    private http: HttpClient,
    private modalService: BsModalService,
    private fb: FormBuilder,
    private populateservice: PopulateService,
    private toastrService: ToastrService,
    private direccionesService: DireccionesService,
    private usersService: UsersService,
    private auth: AuthenticationService
  ) { }

  directionForm = this.fb.group({
    nombre: [this.model.NOMBRE, [Validators.required, Validators.maxLength(50)]],
    direccion: [this.model.DIRECCION, [Validators.required, Validators.maxLength(50)]],
    telefono: [this.model.TELEFONO, [Validators.required, Validators.pattern(/^-?(0|[1-9]\d*)?$/)]],
    poblacion: [this.model.POBLACION, [Validators.required, Validators.maxLength(25)]],
    provincia: [this.model.ID_PROVINCIA, [Validators.required, Validators.min(1)]],
    CODIGO_POSTAL: [this.model.CODIGO_POSTAL, [
      Validators.required,
      Validators.pattern(/^-?(0|[1-9]\d*)?$/),
      Validators.max(52998),
      Validators.maxLength(5)
    ]]
  });

  get nombre() { return this.directionForm.get('nombre'); }
  get direccion() { return this.directionForm.get('direccion'); }
  get telefono() { return this.directionForm.get('telefono'); }
  get poblacion() { return this.directionForm.get('poblacion'); }
  get provincia() { return this.directionForm.get('provincia'); }
  get CODIGO_POSTAL() { return this.directionForm.get('CODIGO_POSTAL'); }

  ngOnInit() {
    this.getAllProvincias();
  }

  onSelect(d: any) {
    this.updateDireccion = d.selected.pop();
  }

  onSelectProvincia(index): void {
    this.selectedIdProvincia = index;
    // this.directionForm.patchValue({ ID_PROVINCIA: this.selectedIdProvincia });
    if (index === '0') {
      this.model.PROVINCIA = undefined;
    } else {
      this.model.PROVINCIA = this.provinciaList.filter(prov => prov.Id === +index)[0].NOMBRE_PROVINCIA;
    }
  }

  onSave() {
    this.nuevaDireccion = this.updateDireccion;
  }

  openNewModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  getAllProvincias() {
    this.populateservice.getAllProvincias()
      .subscribe((provincias: Provincias[]) => {
        this.provinciaList = provincias;
      },
        errorCode => {
          this.statusCode = errorCode;
          this.toastrService.warning('No se han podido cargar las provincias', 'Error al cargar');
        });
  }

  checkCodPostal(value: number) {
    if (value < 1000 || value === undefined) {
      this.minCodPostal = true;
      return;
    }
    this.minCodPostal = false;
  }


  onAddressFormSubmit() {
    this.processValidation = true;
    if (this.directionForm.invalid) {
      return;
    }
    if (this.direcciones.length === 0) {
      this.model.DEFAULT = true;
      this.model.POR_DEFECTO = true;
    } else {
      this.model.DEFAULT = false;
      this.model.POR_DEFECTO = false;
    }
    if (this.idUsuario) {
      this.model.ID_USUARIO = this.idUsuario;
    }
    this.preProcessConfigurations('Añadiendo direccion');
    this.tablaVisible = false;
    this.direccionesService.createAddress(this.model)
      .subscribe(successCode => {
        this.direcciones.push(this.model);
        this.statusCode = successCode;
        this.toastrService.success('Direccion añadida correctamente', 'Direccion correcta');
        this.tablaVisible = true;
        this.model = new Direcciones();
        this.directionForm.reset();
        this.modalRef.hide();
        this.getDirecciones();
      },
        errorCode => {
          this.muestraError(errorCode, '');
          this.tablaVisible = true;
        }
      );
  }

  muestraError(errorCode: HttpErrorResponse, mensaje: string) {
    this.statusCode = errorCode.status;
    // si hay errores extendidos por ADMIn se muestra  uno u otro

    if (mensaje.length <= 0 || !mensaje) {
      if (errorCode.error) {
        mensaje = errorCode.error.Message;
      } else {
        mensaje = errorCode.message;
      }
    }
    this.toastrService.error('Se ha encontrado un error: ' + mensaje, 'Error servidor');
  }

  preProcessConfigurations(mensaje: string) {
    this.mensajeToShow = mensaje;
    this.statusCode = null;
    this.requestProcessing = true;
  }

  getDirecciones() {
    let direcciones$;
    this.auth.isDocOutUser()
      .then((isDocUser: boolean) => {
        if (isDocUser) {
          direcciones$ = this.direccionesService.getDirsOfSuplantedUser(this.idUsuario);
          direcciones$.subscribe((result: Direcciones[]) => {
            this.assignDirs(result);
          });
        } else {
          this.usersService.getUserById(undefined).subscribe((profile: Userprofile) => this.assignDirs(profile.DIRECCIONES));
        }
      });
  }

  assignDirs(dirs: Direcciones[]) {
    if (dirs !== null) {
      this.direcciones = dirs;
    }
  }

  hideDireccionTemplate() {
    this.direccionTemplate.hide();
  }

  selectAddressOnDblClick(event) {
    if (event.type == 'dblclick') {
      this.onSave();
      this.hideDireccionTemplate();
    }
  }

}
